export const SafeArea = ({ children, style }) => {
  return (
    <div
      style={{
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
        paddingLeft: "env(safe-area-inset-left)",
        paddingRight: "env(safe-area-inset-right)",
        ...style
      }}
    >
      {children}
    </div>
  );
};

export default SafeArea;